module.exports = __webpack_public_path__ + "img/classes_app.694d66dd.svg";